import ProductImage from './product-image.js';

export default ProductImage;